import { Component, OnInit } from '@angular/core';
import { LibraryService } from 'src/app/services/Library/library.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';

@Component({
  selector: 'app-book-title',
  templateUrl: './book-title.component.html',
  styleUrls: ['./book-title.component.css']
})
export class BookTitleComponent implements OnInit { 
    Submitted:boolean= false;
  constructor(private  libraryservice: LibraryService,private lookupservice: LookupService, public globalHelper: GlobalHelper, 
    private spinnerService: Ng4LoadingSpinnerService) { }

    currentPage = 1;
    pageSize =20;
    recordCount = 0;
    totalPages = 0;

    numberOfPages() {

        this.totalPages = Math.ceil(this.recordCount / this.pageSize);
    }

    nextPage  () {
        this.currentPage = this.currentPage + 1;

    }

    pageSizes () {
        this.currentPage = 1;
        this.recordCount = 0;
        this.totalPages = 0;

    }
    FilterModel = {

        CurrentIndex: 0,
        PageSize: 20,
        BookTitle:'',
    }

     BookTitleMSTModel =
        {
            BookTitleID: 0,
            BookTitle: '',
            IsActive:true
        }
    BookTitleMSTList = [];

    Clear  () {
        this.BookTitleMSTModel.BookTitle = '';
        this.BookTitleMSTModel.BookTitleID = 0;
        this.Submitted = false;
    }
          

  
    SaveBookTitle  (valid) {     
        this.Submitted=true;
        if (valid) {
          this.spinnerService.show();
          
            this.libraryservice.SaveBookTitle(JSON.stringify(this.BookTitleMSTModel)).subscribe( (response:any) =>{
               
              this.spinnerService.hide();
              
                this.globalHelper.CheckActionStatus(response);
                this.GetAllBookTitleMST();
                this.Clear();
            })
        }
    }
   

    BookTitleMarkActive ( Item) {
     
        this.BookTitleMSTModel.BookTitleID = Item.BookTitleID;
        this.BookTitleMSTModel.IsActive = Item.IsActive == true ? false : true;
       this.spinnerService.show();
        this.libraryservice. BookTitleMarkActive(JSON.stringify(this.BookTitleMSTModel)).subscribe( (response:any) => {
            this.spinnerService.hide();
            this.globalHelper.CheckActionStatus(response);          
            this.GetAllBookTitleMST();

        })

    }

    GetAllBookTitleMST () {
      
        this.FilterModel.CurrentIndex = this.currentPage;
        this.FilterModel.PageSize = this.pageSize;
        this.spinnerService.show();
        this.libraryservice.GetAllBookTitle(JSON.stringify(this.FilterModel)).subscribe( (data:any)=> {

            this.BookTitleMSTList = data.BookTitleMSTList;
            this.recordCount = 0;
            if (this.BookTitleMSTList != null && data.BookTitleMSTList.length > 0) {
                this.recordCount = this.BookTitleMSTList[0].RecordCount;

            }

           this.spinnerService.hide();
            this.numberOfPages();
           
        });
    }



    Edit  (obj) {
        this.BookTitleMSTModel.BookTitle = obj.BookTitle;
        this.BookTitleMSTModel.BookTitleID = obj.BookTitleID;

    }


  ngOnInit() {
    this.GetAllBookTitleMST();
  }

}
